import { GET_PRODUCTS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_PRODUCTS:
            return action.payload;
        default:
            return state;
    }
}